import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";

const MyTradeInsModal = ({
  isOpen,
  onClose,
  onConfirm,
  print = false,
  title,
  body,
  primaryText,
  secondaryText,
  pdfUrl,
}) => {
  // const handlePrint = () => {
  //   if (pdfUrl) {
  //     const printWindow = window.open(pdfUrl, "_blank");
  //     printWindow.onload = () => {
  //       printWindow.print();
  //     };
  //   }
  // };

  // const handlePrimaryAction = () => {
  //   if (print) {
  //     handlePrint();
  //   } else if (onConfirm) {
  //     onConfirm();
  //   }
  // };

  // const modalRef = useRef();

  // useEffect(() => {
  //   const handleOutsideClick = (e) => {
  //     if (modalRef.current && !modalRef.current.contains(e.target)) {
  //       onClose();
  //     }
  //   };
  // });

  if (!isOpen) return null;

  return (
    <>
      {isOpen && (
        <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
          <div className="bg-white rounded-2xl scrollbar-hide w-full max-w-sm mx-auto p-0 flex flex-col items-center relative">
            {/* Header: Logo and Close */}
            <div className="flex items-center justify-between w-full px-6 pt-6">
              <div className="flex-1 flex justify-center">
                <img
                  src="/static/media/logo.4f05a22b8fee49f8826e.jpg"
                  alt="LEGO"
                  className="h-8"
                />
              </div>
              <button
                onClick={onClose}
                className="absolute right-6 top-6 text-2xl text-black"
                aria-label="Close"
              >
                ×
              </button>
            </div>
            {/* Instruction */}
            <div className="w-full text-center mt-4 mb-8 px-6">
              <h2 className="text-xl font-bold">
                Present this QR code when
                <br /> you arrive in store
              </h2>
            </div>
            {/* QR Code */}
            <div className="flex justify-center items-center mb-20 mt-16 ">
              {body}
            </div>
            {/* Done Button */}
            <div className="w-full px-6 pb-6">
              <button
                onClick={onClose}
                className="w-full bg-[#0082C3] text-white text-lg rounded-full py-3"
              >
                Done
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </>
  );
};

MyTradeInsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  primaryText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string.isRequired,
  pdfUrl: PropTypes.string,
  print: PropTypes.bool,
};

export default MyTradeInsModal;
